import { useState } from 'react';
import TopMetricLayout from './components/TopMetricLayout';
import TopMetricPopup from './components/TopMetricPopup/TopMetricPopup';
import LoadingRows from './components/LoadingRows';
import NoDataRows from './components/NoDataRows';
import DataRows from './components/DataRows';
import { TopMetricsChartProps } from './types';

const TopMetricsChart = <T extends string>(props: TopMetricsChartProps<T>) => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const handleShowMore = () => {
        setIsPopupOpen(true);
        props.onShowMore?.();
    };

    const handleClosePopup = () => {
        setIsPopupOpen(false);
    };

    if (props.tabs) {
        const { label, tabs, selectedTab, onTabChange, onInvestigationClick } = props;

        const handleInvestigateClick = (guid: string) => {
            onInvestigationClick?.(guid, selectedTab);
        };

        const currentTab = tabs.find((tab) => tab.value === selectedTab);

        if (currentTab?.previewLoading && currentTab?.previewData.length === 0) {
            return <TopMetricLayout tabs={tabs} onTabChange={onTabChange} onShowMore={() => { }} label={label} selectedTab={selectedTab}><LoadingRows /></TopMetricLayout>;
        }

        if (currentTab?.previewData.length === 0) {
            return <TopMetricLayout tabs={tabs} onTabChange={onTabChange} onShowMore={() => { }} label={label} selectedTab={selectedTab}><NoDataRows /></TopMetricLayout>;
        }

        return (
            <>
                <TopMetricLayout
                    onShowMore={handleShowMore}
                    label={label}
                    selectedTab={selectedTab}
                    onTabChange={onTabChange}
                    tabs={tabs}>
                    <DataRows data={currentTab?.previewData ?? []} onInvestigateClick={handleInvestigateClick} />
                </TopMetricLayout>
                <TopMetricPopup
                    open={isPopupOpen}
                    onClose={handleClosePopup}
                    selectedTab={selectedTab}
                    title={label}
                    tabs={tabs}
                />
            </>
        );
    }

    const { label, data, fullData, loading, fullLoading, onInvestigationClick } = props;

    const handleInvestigateClick = (guid: string) => {
        onInvestigationClick?.(guid);
    };

    if (loading && data.length === 0) {
        return <TopMetricLayout onShowMore={() => { }} label={label} disabled={true}><LoadingRows /></TopMetricLayout>;
    }

    if (data.length === 0) {
        return <TopMetricLayout onShowMore={() => { }} label={label} disabled={true}><NoDataRows /></TopMetricLayout>;
    }

    return (
        <>
            <TopMetricLayout onShowMore={handleShowMore} label={label}>
                <DataRows data={data} onInvestigateClick={handleInvestigateClick} />
            </TopMetricLayout>
            <TopMetricPopup
                open={isPopupOpen}
                onClose={handleClosePopup}
                title={label}
                singleData={{
                    data: fullData,
                    loading: fullLoading
                }}
            />
        </>
    );
};

export default TopMetricsChart;
